import { render } from "./UIExamplePlaceholder.vue?vue&type=template&id=05fd0d1b&ts=true"
import script from "./UIExamplePlaceholder.vue?vue&type=script&lang=ts"
export * from "./UIExamplePlaceholder.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\csit142\\source\\repos\\Website.TorbayDesignGuide\\Website.TorbayDesignGuide.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__